export default __webpack_public_path__ + "static/media/tooltip-numero-servicio.3f2d59a2.png";